/**
 * Shared HITL 3.0 font size, defined once so it can be tuned in a single place
 * and reused across the hitl_3_0 UI — intent buttons, live-transcript messages,
 * Customer Pulse, modifier choices and the shortcuts popover.
 *
 * IMPORTANT: apply this ONLY behind the hitl_3_0 flag / inside hitl3-only
 * components. The legacy layout keeps its own sizes and must not reference this,
 * so bumping the value here never affects the old UI.
 */
export const HITL3_FONT_SIZE = '0.875rem'; // 14px at the 16px root

/**
 * Panel/section TITLE size for hitl_3_0 surfaces, one step above the body token.
 *
 * Deliberately a SECOND constant rather than a bump of HITL3_FONT_SIZE: that one is
 * the shared body size across 20+ call sites (intent buttons, transcript, Customer
 * Pulse, shortcuts popover) and raising it would resize all of them.
 *
 * Introduced for HITL-1501's issue-flag panel, whose heading has to read as a panel
 * title rather than one more line of body text.
 */
export const HITL3_TITLE_FONT_SIZE = '1.125rem'; // 18px at the 16px root

/**
 * Chip text size for the hitl_7_0 Pulse strip, and the icon size that sits
 * beside it.
 *
 * HITL-1663 turns the Copilot card into a row of chips. At the 14px body token
 * those pills are big enough that three rows of them eat the height the ticket
 * set out to give back to the conversation, so 7.0 drops chip text to 12px —
 * the same size as the header text HITL-1662 settled on, so the two compact
 * surfaces read as one decision.
 *
 * A THIRD constant, not a change to HITL3_FONT_SIZE: that token is the shared
 * body size across the whole 3.0 UI and shrinking it would resize the intent
 * buttons, the transcript and the shortcuts popover for everyone, flag off
 * included.
 *
 * IMPORTANT: apply ONLY behind hitl_7_0.
 */
export const HITL7_CHIP_FONT_SIZE = '0.75rem'; // 12px at the 16px root
// Icons keep their existing ratio to the text they sit next to (~0.96x), so
// they shrink with it instead of dominating the smaller pill.
export const HITL7_CHIP_ICON_SIZE = '0.72rem';
